import(/* webpackMode: "eager" */ "/app/libs/stf.m.product/src/screen.product-list/product-list.tsx");
